import { render, staticRenderFns } from "./GridRevision.vue?vue&type=template&id=5557950c&"
import script from "./GridRevision.vue?vue&type=script&lang=js&"
export * from "./GridRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports